import { gql } from '@apollo/client';
const GET_PRODUCT_MAIN_CATEGORIES = gql `
  query GetProductMainCategories($first: Int = 25, $after: String = "") {
    autocomplete {
      productMainCategories(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            name
            description
            thumbnail
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_MAIN_CATEGORIES;
